import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { useState } from "react";
import { usePatients } from "@/hooks/api/use-api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { ArrowLeft, Save, Send } from "lucide-react";

export const Route = createFileRoute("/claims/new/")({
  component: NewClaim,
});

function NewClaim() {
  const nav = useNavigate();
  const { data: pts } = usePatients();
  const [form, setForm] = useState({
    patientId: "",
    insuranceType: "PRIVATE",
    acts: "",
    notes: "",
  });

  return (
    <div className="space-y-4 p-6">
      <Link to="/claims" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-3 w-3" /> Retour
      </Link>

      <div>
        <h1 className="text-2xl font-bold tracking-tight">Nouvelle feuille de soins</h1>
        <p className="mt-1 text-sm text-muted-foreground">CNSS / CNOPS / AMO / Privé</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Actes &amp; produits</CardTitle>
          <CardDescription>Codage CCAM/NGAP + LPP pour dispositifs</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div>
            <label className="text-xs font-medium">Patient</label>
            <select
              value={form.patientId}
              onChange={(e) => setForm({ ...form, patientId: e.target.value })}
              className="mt-1 w-full rounded-md border border-white/10 bg-white/5 px-3 py-2 text-sm"
            >
              <option value="">— Choisir —</option>
              {pts?.items.map((p) => <option key={p.id} value={p.id}>{p.family} {p.given} · {p.mrn}</option>)}
            </select>
          </div>
          <div>
            <label className="text-xs font-medium">Type d'assurance</label>
            <select
              value={form.insuranceType}
              onChange={(e) => setForm({ ...form, insuranceType: e.target.value })}
              className="mt-1 w-full rounded-md border border-white/10 bg-white/5 px-3 py-2 text-sm"
            >
              <option value="PRIVATE">Privé</option>
              <option value="CNSS">CNSS</option>
              <option value="CNOPS">CNOPS</option>
              <option value="AMO">AMO</option>
            </select>
          </div>
          <div>
            <label className="text-xs font-medium">Actes (CCAM/NGAP, séparés par virgule)</label>
            <Textarea
              placeholder="Ex: C consultation, K5 ECG, JKHD0010 bilan lipidique"
              value={form.acts}
              onChange={(e) => setForm({ ...form, acts: e.target.value })}
              rows={3}
            />
          </div>
          <div>
            <label className="text-xs font-medium">Notes clinicien</label>
            <Textarea
              placeholder="Observations, contexte clinique..."
              value={form.notes}
              onChange={(e) => setForm({ ...form, notes: e.target.value })}
              rows={2}
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline"><Save className="h-4 w-4 mr-1" /> Brouillon</Button>
            <Button><Send className="h-4 w-4 mr-1" /> Soumettre à l'organisme</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
